var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 109,
    viewBox: "0 0 110 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96894 98.1039L0 0H109.578L99.5962 98.0883L54.7226 109L9.96894 98.1039Z",
    fill: "#1572B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7892 100.661L91.052 91.8442L99.5829 8.02316H54.7892V100.661Z",
    fill: "#33A9DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7892 43.565H72.9428L74.1945 31.2441H54.7892V19.2112H54.838H89.1878L88.8594 22.4384L85.4905 55.5978H54.7892V43.565Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8736 74.8129L54.8114 74.8285L39.534 71.2082L38.5575 61.6123H31.1319H24.7848L26.7066 80.5043L54.807 87.3479L54.8736 87.3324V74.8129Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7755 55.0878L70.1244 71.2003L54.8247 74.8207V87.3401L82.9473 80.5043L83.1559 78.4722L85.5394 55.0878H71.7755Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.838 19.2112V26.6855V31.2129V31.2441H21.7444H21.7L21.4248 28.5385L20.7989 22.4384L20.4705 19.2112H54.838Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7892 43.5649V51.0392V55.5666V55.5978H39.747H39.7026L39.4274 52.8922L38.8061 46.7921L38.4776 43.5649H54.7892Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.56615f65dda9491d88b08a8d40eeac1b.svg";
export { ForwardRef as ReactComponent };